import React, { useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter , Spinner} from 'reactstrap';
import axios from "axios";
import { t } from 'i18next';
import './style.css';
import LogDetails from './LogDetails.js';
import { BACKEND_URL_LOG, LOG_URL} from "../../config/const.js";
const ListLogs = ({ open, onClose , name , startDate , endDate ,groupId,type , teamArray,cleanroom }) => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [logId, setLogId] = useState(null);
    const [openLogDetails, setOpenLogDetails] = useState(false);

    useEffect(() => {
        console.log(name);
     if (open) {
        fetchLogs();
    }
    }, [open]);

    const handleLogClick = (id) => {
        setLogId(id);
        setOpenLogDetails(true);
      };

      const handleResolveLogClick = (id,dayNotFormatted) => {
           const token = localStorage.getItem("token");
           const lang = localStorage.getItem("lang");
           const currentOrg = localStorage.getItem("currentOrg");
           const day = dayNotFormatted.replace(/-/g, "/");
           console.log(day);
           const type = 1
           const payload = { token, lang , type , id ,day ,currentOrg};
           const encoded = 'REROUTERESOLVELOG:' + btoa(JSON.stringify(payload));
       
           // 1) Open a blank tab
           const w = window.open('about:blank', '_blank'); // avoid URL here
           if (!w) {
             alert('Please allow pop-ups for this site.');
             return;
           }
       
           // 2) Put the payload on the CHILD window, not the current one
           w.name = encoded;
       
           // 3) Navigate the child to your route
           w.location = `${LOG_URL}/reroute/registre`; // e.g. https://other-app.com/reRoute

      };

    const fetchLogs = async () => { 
        setLoading(true);
        setError(null);
        try {
            const config = {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              };
            const response = await axios.post(BACKEND_URL_LOG+ "logs/details", {
                startDate,
                endDate,
                clientId: groupId,
                type,
                teamArray: teamArray || "",
                cleanroom: cleanroom ,
                condition: name
            },config);
            setLogs(response); // Stocker les logs dans le state
        } catch (error) {
            setError("Erreur lors de la récupération des logs");
            console.error("Erreur API:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={open} centered size="lg" >
            <ModalHeader className="detail-header" style={{ width: '100%' }}>
                <div className="modal-header-content">
                    <span className="modal-title">{t(name)}</span>
                    <Button className="cancel-btn" onClick={onClose}>
                        {t('CLOSE')}
                    </Button>
                </div>
            </ModalHeader>
            <ModalBody className="modal-body-custom">
                {loading ? (
                    <div className="text-center mt-5">
                                <Spinner
                                color="primary"
                                style={{
                                    height: '3rem',
                                    width: '3rem'
                                    }}
                                >
                               Loading...
                                </Spinner>
                                <div className="text-center mt-2">
                              {t("loading...")}
                              </div>
                              </div>
                ) : error ? (
                    <p style={{ color: "red" }}>{error}</p>
                ) : logs && logs.length > 0 ? (  // Vérification supplémentaire
                    <div className="log-container">
                        <table className="log-table">
                            <thead> 
                                <tr>
                                    <th>{t("logs")}</th>
                                    <th>{t("Date")}</th>
                                </tr>
                            </thead>
                            <tbody  style={{ color: 'black' }}>
                                {logs.map((log, index) => (
                                    <tr key={index} className="row-doc" onClick={() => {
                                        if (name.includes("-completed")) {
                                        handleLogClick(log.id);
                                        }else if(name.includes("-notCompleted")){
                                            handleResolveLogClick(log.id,log.log_date)
                                        }
                                    }}
                                    style={{
                                        cursor:"pointer",
                                    }}>
                                        <td>{log.title || t("Log sans titre")}</td>
                                        <td style={{textAlign:"center"}}>{log.log_date || "N/A"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <p className="text-center text-muted">{t('NoLogs')}</p>
                )}
            </ModalBody>

            {openLogDetails && <LogDetails logId={logId} openLogDetails={openLogDetails} onCloseLogDetails={() => setOpenLogDetails(false)} />}

   
        </Modal>
    );
};

export default ListLogs;
